import type { AutoCompleteProps as AntAutoCompleteProps } from "antd";
import { AutoComplete as AntAutoComplete, Input } from "antd";
import React, { useState } from "react";
export interface AutoCompleteOption {
  value?: string | number | null;
  label: React.ReactNode;
}
export interface AutoCompleteProps
  extends Omit<AntAutoCompleteProps, "options"> {
  options: AutoCompleteOption[];
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
  onSearch?: (value?: string) => void;
  onSelect?: (value: string, option: AutoCompleteOption) => void;
}
const AutoComplete: React.FC<AutoCompleteProps> = ({
  options,
  placeholder = "Type to search...",
  disabled = false,
  allowClear = false,
  onSearch,
  onSelect,
  ...props
}) => {
  const [inputValue, setInputValue] = useState<string>("");
  const handleSearch = (value: string) => {
    setInputValue(value);
    if (onSearch) {
      onSearch(value);
    }
  };
  const handleSelect = (value: string, option: any) => {
    setInputValue(value);
    if (onSelect) {
      onSelect(value, option);
    }
  };
  return (
    <AntAutoComplete
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={allowClear}
      onSearch={handleSearch}
      onSelect={handleSelect}
      {...props}
    >
      <Input aria-label={placeholder} />
    </AntAutoComplete>
  );
};
export default AutoComplete;
